import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { BikeService } from '../../../../services/bike.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { HelpersService } from '../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-bikes',
  templateUrl: './bikes.component.html',
  styleUrls: ['./bikes.component.scss']
})
export class BikesComponent implements OnInit, OnDestroy {

  @Input() cyclist;
  @Input() singleBike : boolean = false;
  @Input() bikeId;
  
  public loading : boolean = false;
  public bikes : any = [];
  public columns: any = [
    { header: this.translate.instant('general.headers.manufacturer'), field: "manufacturer", type: 'string' },
    { header: this.translate.instant('general.headers.model'), field: "model", type: 'string' },
    { header: this.translate.instant('general.headers.year'), field: "year", type: 'string' },
    { header: this.translate.instant('bikeshop.modal.shared.bike.serial_no'), field: "serialNumber", type: 'string' },
    { header: this.translate.instant('general.headers.last_serviced'), field: "lastService", type: 'date' }
  ];
  public selectedBike : any = null;
  public newBike : any = null;
  public bikeGear : any = null;
  public distanceMetric = 'km';
  public countryData : any = {};
  public partnerData : any = {};

  public showTransfer: boolean = false;
  public searchTerm: string = '';
  public page: number = 0;          // the API is 0-based
  public limit: number = 10;
  public totalRecords: number = 0;
  private searchChanged$: Subject<void> = new Subject<void>();
  private searchSubscription: Subscription;
  private bikesRequest: Subscription;


  public selectedBikes: any[] = [];
  public transferBikes: boolean = false;
  constructor(
    private helpersService : HelpersService,
    private cyclistService : CyclistService,
    private bikeService : BikeService,
    private translate : TranslateService
  ) { 
    this.distanceMetric = this.helpersService.getDistanceMetric();
  }

  ngOnInit() {
    this.partnerData = this.helpersService.getPartnerData();
    this.countryData = this.helpersService.getCountryData();

    this.searchSubscription = this.searchChanged$
      .pipe(debounceTime(400))
      .subscribe(() => {
        this.page = 0;
        this.selectedBikes = [];
        this.getBikes();
      });

    if(this.cyclist && this.cyclist.ID){
      this.getBikes();
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
    this.bikesRequest?.unsubscribe();
  }

  getBikes() {
    this.loading = true;
    this.bikesRequest?.unsubscribe();   // cancel any request still in progress
    this.bikesRequest = this.cyclistService.getBikesForCyclistPaged(this.cyclist.ID, this.partnerData.PartnerType, this.partnerData.ID,
      this.page, this.limit, this.searchTerm?.trim() ?? '').subscribe(res => {
        this.bikes = res.bikes.map(x => { return { ...x, ID: x.id } });
        this.totalRecords = res.totalCount;
        this.loading = false;
      }, () => this.loading = false);
  }

  paginate(event) {
    this.page = event.page;
    this.limit = event.rows;
    this.getBikes();
  }

  onSearchChanged() {
    this.searchChanged$.next();
  }

  viewBike(bike){
    this.bikeService.getActiveGear(bike.ID).subscribe(gear=>{
      this.bikeGear = gear;
      this.selectedBike = bike;
    });    
  }

  setCompleted(value: boolean) {
    console.log('Setting completed to:', value);
    if (value) {
      this.selectedBike = null;
      this.showTransfer = false;
      this.transferBikes = false;
      this.selectedBikes = [];
      this.getBikes();
    }
  }

  toggleBikeSelection(bike: any): void {
    const idx = this.selectedBikes.findIndex(b => b.ID === bike.ID);
    if (idx > -1) {
      this.selectedBikes.splice(idx, 1);
    } else {
      this.selectedBikes.push(bike);
    }
  }

  isBikeSelected(bike: any): boolean {
    return this.selectedBikes.some(b => b.ID === bike.ID);
  }

  isAllSelected(): boolean {
    return this.bikes.length > 0 && this.bikes.every(b => this.isBikeSelected(b));
  }

  toggleSelectAll(): void {
    if (this.isAllSelected()) {
      this.selectedBikes = this.selectedBikes.filter(b => !this.bikes.some(f => f.ID === b.ID));
    } else {
      this.bikes.forEach(b => {
        if (!this.isBikeSelected(b)) {
          this.selectedBikes.push(b);
        }
      });
    }
  }

  transferSelected(): void {
    // TODO: wire up multi-transfer
    console.log('Transfer selected bikes:', this.selectedBikes);
    this.transferBikes = true;
    console.log('Transfer bikes flag set to true');
  }

}
